"use strict";
//  Copyright 2018, Venkat Peri.
//
//  Permission is hereby granted, free of charge, to any person obtaining a
//  copy of this software and associated documentation files (the
//  "Software"), to deal in the Software without restriction, including
//  without limitation the rights to use, copy, modify, merge, publish,
//  distribute, sublicense, and/or sell copies of the Software, and to permit
//  persons to whom the Software is furnished to do so, subject to the
//  following conditions:
//
//  The above copyright notice and this permission notice shall be included
//  in all copies or substantial portions of the Software.
//
//  THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
//  OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
//  MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
//  NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
//  DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
//  OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
//  USE OR OTHER DEALINGS IN THE SOFTWARE.
Object.defineProperty(exports, "__esModule", { value: true });
var Logger_1 = require("../Logger");
var Deferred_1 = require("./Deferred");
var uniqId_1 = require("./uniqId");
/**
 * @hidden
 */
var Log = Logger_1.default("Pending");
/**
 * @hidden
 */
var Pending = /** @class */ (function () {
    function Pending() {
        this.pending = {};
    }
    Pending.prototype.create = function () {
        var defer = new Deferred_1.default();
        var id = uniqId_1.uniqId();
        Log.i("created: " + id);
        this.pending[id] = defer;
        return id;
    };
    Pending.prototype.get = function (id) {
        return this.pending[id].promise;
    };
    Pending.prototype.remove = function (id) {
        delete this.pending[id];
    };
    Pending.prototype.resolve = function (id, x) {
        Log.i("resolve: " + id);
        this.pending[id].resolve(x);
    };
    Pending.prototype.reject = function (id, x) {
        Log.i("reject: " + id);
        this.pending[id].reject(x);
    };
    Pending.prototype.cleanup = function () {
        var completed = Object.entries(this.pending)
            .filter(function (_a) {
            var id = _a[0], defer = _a[1];
            return defer.completed;
        });
        for (var _i = 0, completed_1 = completed; _i < completed_1.length; _i++) {
            var id = completed_1[_i][0];
            this.remove(id);
        }
    };
    return Pending;
}());
exports.default = Pending;
//# sourceMappingURL=Pending.js.map